// Constant imports:
import { GET_SIGTI_API_URL } from '../../config';
// Service imports:
import { bugsnagNotify, fetchResponseToDetailedString } from '../../services/bugsnagUtils';
// Type imports:
import { AppDispatch } from '../../index'; // Use the root dispatch type from your store
import { DashboardActions, SET_CURRENT_TRADING_DAY, SET_DAY_RANGE, REQUEST_AUTOCOMPLETE_ITEMS_WAITING, REQUEST_AUTOCOMPLETE_ITEMS_SUCCESS, REQUEST_AUTOCOMPLETE_ITEMS_FAILURE, SET_SELECTED_TICK, SET_CHECKED_ADDITIONAL_TICK_IDS } from '../../types/redux/DashboardTypes';
import { TickData } from '../../types/api/Types';
import { IAutoCompleteItem } from '../../types/api/DashboardTypes';
import { requestAutoCompleteItemsQuery } from '../queries/autoCompleteItems';
import { REQUEST_FORBIDDEN } from '../../types/redux/LoginTypes';

// ================================ CHECK IF FORBIDDEN RESOURCE (LOGOUT IF TRUE) ================================
const checkIfForbiddenResource = (responseBody: any) => {
    if (responseBody.errors && responseBody.errors[0].message === "Forbidden resource") {
        return true;
    }
    return false;
}

const requestForbidden = () => ({
    type: REQUEST_FORBIDDEN,
});

/* SET TRADING DAY */
export const setCurrentTradingDay = (newTradingDay: string, skipPushingToHistory?: boolean) => {
    return (dispatch: AppDispatch) => {
        const setCurrentTradingDayAction: DashboardActions = {
            type: SET_CURRENT_TRADING_DAY,
            payload: {
                newTradingDay,
                skipPushingToHistory: skipPushingToHistory ?? false
            }
        };
        dispatch(setCurrentTradingDayAction);
    }
}

/* SET DAY RANGE */
export const setDayRange = (fromDate: string, toDate: string, skipPushingToHistory?: boolean) => {
    return (dispatch: AppDispatch) => {
        const setDayRangeAction: DashboardActions = {
            type: SET_DAY_RANGE,
            payload: {
                fromDate,
                toDate,
                skipPushingToHistory: skipPushingToHistory ?? false
            }
        };
        dispatch(setDayRangeAction);
    }
}

/* REQUEST AUTCOMPLETE ITEMS */
const requestAutoCompleteItemsThunk = async (dispatch: AppDispatch, accessToken: string) => {
    dispatch(requestAutoCompleteItemsWaiting());

    // Start request.
    const url = GET_SIGTI_API_URL();
    const query = requestAutoCompleteItemsQuery();

    const queryObject = {
        query,
    };

    try {
        const response = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            credentials: 'include',
            body: JSON.stringify(queryObject)
        });

        if (response.ok) {
            const responseBody = await response.json();

            // logOut if forbidden resource.
            if (checkIfForbiddenResource(responseBody)) {
                dispatch(requestForbidden());
            }
            if (!responseBody.data) {
                dispatch(requestAutoCompleteItemsFailure('Session Expired'));
                return;
            }
            dispatch(requestAutoCompleteItemsSuccess(responseBody.data.publicAutoCompleteItems));
        } else {
            const { errorString } = await fetchResponseToDetailedString('Request Autocomplete Items', response);
            bugsnagNotify(new Error(errorString));
            dispatch(requestAutoCompleteItemsFailure('Request Failed'));
        }
    } catch (e) {
        bugsnagNotify(e as Error);
        dispatch(requestAutoCompleteItemsFailure('Network Error'));
    }
}

const requestAutoCompleteItemsWaiting = (): DashboardActions => ({
    type: REQUEST_AUTOCOMPLETE_ITEMS_WAITING
});

const requestAutoCompleteItemsSuccess = (autoCompleteItems: IAutoCompleteItem[]): DashboardActions => ({
    type: REQUEST_AUTOCOMPLETE_ITEMS_SUCCESS,
    autoCompleteItems
});

const requestAutoCompleteItemsFailure = (error: string): DashboardActions => ({
    type: REQUEST_AUTOCOMPLETE_ITEMS_FAILURE,
    error
});

export const requestAutoCompleteItems =
    (accessToken: string) =>
    (dispatch: AppDispatch) =>
    requestAutoCompleteItemsThunk(dispatch, accessToken);

/* SET SELECTED TICK */

export const setSelectedTick = (tick: TickData | null) => {
    return (dispatch: AppDispatch) => {

        const setSelectedTickAction: DashboardActions = {
            type: SET_SELECTED_TICK,
            payload: tick
        };
        dispatch(setSelectedTickAction);
    }
}

/* Additional timestamp checkbos */

export const setCheckedAdditionalTickIds = (checkedAdditionalTickIds: string[]) => {
    return (dispatch: AppDispatch) => {
        dispatch({
            type: SET_CHECKED_ADDITIONAL_TICK_IDS,
            payload: { checkedAdditionalTickIds }
        });
    };
};